import { getRowPropsWithDeletedHighlight } from "@/lib/table/getRowPropsWithDeletedHighlight";
import { useInvoiceSpecificationsColumnOverrides } from "@/modules/projects/hooks/useInvoiceSpecificationsSectionColumnOverrides";
import { ReadInvoiceSpecification } from "@/types/invoiceSpecification";
import { useMemo } from "react";

export function useInvoiceSpecificationList() {
  const columnOverrides = useInvoiceSpecificationsColumnOverrides();

  const tableFeatures = useMemo(
    () => ({
      enableShowDeletedToggle: true,
      getRowProps: getRowPropsWithDeletedHighlight<ReadInvoiceSpecification>(
        (row) => !!row.deleted_at,
      ),
    }),
    [],
  );

  return { columnOverrides, tableFeatures };
}
